var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{style:({ width: `${_vm.width}px` }),attrs:{"overlayClassName":"tooltip-wrapper"}},[_c('template',{slot:"title"},[_vm._t("title")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }